<ion-header>
  <ion-toolbar>
    <ion-title>Addison Export für {{ monthYearLabel }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 15px 15px 0 15px">
    Bitte wählen Sie die Mitarbeiter aus, deren Stunden exportiert werden
    sollen. Die Export-Datei landet im Download-Ordner Ihres Computers.
    Technisch bedingt können wir bestehende Dateien mit gleichem Namen in Ihrem
    Download-Ordner nicht überschreiben. Ihr Computer hängt in diesem Fall eine
    Zahl an den Dateinamen an, um Duplikate zu vermeiden. Damit die Datei von
    Addison korrekt eingelesen werden kann ist es jedoch zwingend notwendig,
    dass die Datei <b>IMP_LBW.TXT</b> heißt. Möglicherweise müssen Sie die
    exportierte Datei also umbenennen, bevor Sie sie in Addison importieren
    können.
  </div>
  @if(monthHasUnapprovedEntries){
  <div class="info-box">
    <div class="centered">
      <ion-icon
        size="small"
        name="information-circle-outline"
        style="margin-right: 4px"
      ></ion-icon>
      Für diesen Monat gibt es noch unbestätigte Arbeitszeiten.
    </div>
  </div>
  }
  <div class="custom-table">
    <div class="row header">
      <div class="col">
        <ion-checkbox
          [checked]="isAllSelected()"
          (ionChange)="toggleAll($event.detail.checked)"
          (click)="$event.stopPropagation()"
        ></ion-checkbox>
      </div>

      <div class="col grow">Alle auswählen</div>
    </div>

    @for (user of users; track user) {
    <div class="row">
      <div class="col">
        <ion-checkbox
          (click)="$event.stopPropagation()"
          [checked]="isSelected(user.userName)"
          (ionChange)="toggleSelection(user.userName, $event.detail.checked)"
        >
        </ion-checkbox>
      </div>
      <div class="col grow">{{ user.firstName }} {{ user.lastName }}</div>
    </div>
    }
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      expand="block"
      [disabled]="selectedUserNames.size == 0"
      (click)="exportSelected()"
    >
      Exportieren
    </ion-button>
  </ion-toolbar>
</ion-footer>
